module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-p-500-f1466fb4633ba547b441b19341b06eeb.jpg";